var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 錄取後可上班時間 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    " After recruited, can start work time "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("el-date-picker", {
                                            staticClass: "w-100",
                                            attrs: {
                                              type: "date",
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options": {
                                                disabledDate:
                                                  _vm.$common
                                                    .disabledDateBeforeToday,
                                              },
                                              placeholder: "YYYY-MM-DD",
                                            },
                                            model: {
                                              value:
                                                _vm.workedInfo
                                                  .AvailableOnBoardDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.workedInfo,
                                                  "AvailableOnBoardDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "workedInfo.AvailableOnBoardDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 招募來源管道 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Recruitment Source Channel"),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("div", { staticClass: "field-title" }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", { style: { color: _vm.fontColor } }, [
                              _vm._v(" 是否收到日月光主動邀約? "),
                              _c("span", { staticClass: "en-text" }, [
                                _vm._v(
                                  "Have you received an unsolicited invitation from ASE?"
                                ),
                              ]),
                            ]),
                          ]),
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.workedInfo.IsInvited,
                                                  expression:
                                                    "workedInfo.IsInvited",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.workedInfo.IsInvited,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.workedInfo,
                                                    "IsInvited",
                                                    true
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.workedInfo.IsInvited,
                                                  expression:
                                                    "workedInfo.IsInvited",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.workedInfo.IsInvited,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.workedInfo,
                                                    "IsInvited",
                                                    false
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors }) {
                              return [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "field" }, [
                                    _c("div", { staticClass: "field-title" }, [
                                      _c(
                                        "span",
                                        { style: { color: _vm.fontColor } },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _vm._v(
                                            " 您是如何得知日月光的招募資訊？(第1到第13題請擇一填寫) "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "en-text" },
                                            [
                                              _vm._v(
                                                "How did you hear about ASE recruitment?(Please choose one from questions 1 to 13)"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  errors[0]
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v(" " + _vm._s(errors[0]) + " ")]
                                      )
                                    : _vm._e(),
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 1.收到日月光邀約 Received invitation from ASE： "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 2,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            2
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              2
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v("電話邀約 Invite by phone call"),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 3,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            3
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              3
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "公司簡訊通知 Notify by Co. text messages "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 2.親朋好友介紹 Introduce by friends and relatives： "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 0,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            0
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              0
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "介紹人是員工 Introduce by employee "
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 1,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            1
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              1
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "介紹人非員工 Introduce by non employee"
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(" 3.前員工 Previous employee： "),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 4,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            4
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              4
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "公司電話邀約 Invite by Co. phone call "
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 5,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            5
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              5
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "公司簡訊通知 Notify by Co. text messages"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 6,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            6
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              6
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "自行回廠 Decide on my own to return back factory"
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 4.徵才活動 Recruitment activity： "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 7,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            7
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              7
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "南桃園【中壢、平鎮、龍潭、楊梅、觀音、新屋】South Taouyuan [Chungli, Pingchen, Longtan, Yangmei, Kuanyin, Sinwu]"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 8,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            8
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              8
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "北桃園【桃園、八德、大溪、龜山、蘆竹、大園、復興】North Taoyuan [Taoyuan, Bade, Daxi, Gueishan, Luzhu, Dayuan, Fuxing]"
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 9,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              9
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                9
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            "校園徵才，學校 Recruit at school, school："
                                          ),
                                        ]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 9,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescActivityShool,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescActivityShool",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescActivityShool",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 10,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              10
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                10
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            "專業機構，機構 Special organization, organization："
                                          ),
                                        ]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 10,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescActivityOrg,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescActivityOrg",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescActivityOrg",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 11,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              11
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                11
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("其它 Others：")]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 11,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescActivityOther,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescActivityOther",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescActivityOther",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 5.就業服務站推薦 Recommend by employment service center： "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 12,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            12
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              12
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "中壢就服站 Chungli employment service center"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 13,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            13
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              13
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "桃園就服站 Taoyuan employment service center"
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 14,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              14
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                14
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("其它 Others")]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 14,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescCenterOther,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescCenterOther",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescCenterOther",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [_vm._v(" 6.傑報 Jye-Baw： ")]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 15,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            15
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              15
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "傑報Line@官方帳號 Jye-Baw Line@official account"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 16,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            16
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              16
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "便利商店便利通 Convenience stores front cover"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 17,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            17
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              17
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "0800網路平台 0800 network platform"
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 7.大型廣告輸出 Large advertisement output： "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 18,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            18
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              18
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v("布條 Banner")]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 19,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            19
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              19
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v("看板 Billboard")]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 20,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            20
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              20
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v("LED牆 LED wall")]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [_vm._v(" 8.宣傳單 Flyer： ")]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 21,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            21
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              21
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "中壢就服站 Chungli employment service center"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 22,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            22
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              22
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "桃園就服站 Taoyuan employment service center"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 23,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            23
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              23
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "里長辦公處 Village representative"
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 24,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              24
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                24
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("其它 Others")]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 24,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescFlyerOther,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescFlyerOther",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescFlyerOther",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 9.人力銀行主動求職 Apply at job ban： "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 25,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            25
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              25
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v("104")]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 26,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            26
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              26
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v("1111")]),
                                    ]),
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 27,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              27
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                27
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [_vm._v("其他 Others")]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 27,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescJobBankOther,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescJobBankOther",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescJobBankOther",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(" 10.報紙 Newspaper： "),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 28,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            28
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              28
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v("自由時報 Liberty times"),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 29,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            29
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              29
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v("中國時報 China times"),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 30,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            30
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              30
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v("求職便利通 Benliton.com"),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(" 11.網路平台 Internet platform"),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 31,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            31
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              31
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "日月光Line@官方帳號 ASE Line@official account"
                                        ),
                                      ]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 32,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            32
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              32
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v("Facebook (FB)")]),
                                    ]),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.workedInfo.RecruitmentSource,
                                            expression:
                                              "workedInfo.RecruitmentSource",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: 33,
                                          checked: _vm._q(
                                            _vm.workedInfo.RecruitmentSource,
                                            33
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.workedInfo,
                                              "RecruitmentSource",
                                              33
                                            )
                                          },
                                        },
                                      }),
                                      _c("span", [_vm._v("Instagram (IG)")]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 12.Hunter 推薦 Recommended by Hunter"
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 34,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              34
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                34
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            "Hunter 推薦 Recommended by Hunter"
                                          ),
                                        ]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 34,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescHunter,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescHunter",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescHunter",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("div", { staticClass: "radio-title" }, [
                                    _c("span", [
                                      _vm._v(
                                        " 13.其他招募來源 Other recruitment source"
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "radio-wrap" }, [
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.workedInfo
                                                  .RecruitmentSource,
                                              expression:
                                                "workedInfo.RecruitmentSource",
                                            },
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: 35,
                                            checked: _vm._q(
                                              _vm.workedInfo.RecruitmentSource,
                                              35
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSource",
                                                35
                                              )
                                            },
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            "其他招募來源 Other recruitment source"
                                          ),
                                        ]),
                                        _c("el-input", {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "auto",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.workedInfo
                                                .RecruitmentSource !== 35,
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.workedInfo
                                                .RecruitmentSourceDescOtherSource,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.workedInfo,
                                                "RecruitmentSourceDescOtherSource",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "workedInfo.RecruitmentSourceDescOtherSource",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 曾任職於本公司？ "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Employee of this Co. before?"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.workedInfo
                                                      .HasWorkedInCompany,
                                                  expression:
                                                    "workedInfo.HasWorkedInCompany",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.workedInfo
                                                    .HasWorkedInCompany,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.workedInfo,
                                                    "HasWorkedInCompany",
                                                    true
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.workedInfo
                                                      .HasWorkedInCompany,
                                                  expression:
                                                    "workedInfo.HasWorkedInCompany",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.workedInfo
                                                    .HasWorkedInCompany,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.workedInfo,
                                                    "HasWorkedInCompany",
                                                    false
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm.workedInfo.HasWorkedInCompany
                      ? _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("div", { staticClass: "field-title" }, [
                              _vm.workedInfo.HasWorkedInCompany
                                ? _c("span", { staticClass: "mark" }, [
                                    _vm._v("*"),
                                  ])
                                : _vm._e(),
                              _c("span", { style: { color: _vm.fontColor } }, [
                                _vm._v(
                                  " 備註(工號、任職期間、單位站點、離職原因) "
                                ),
                                _c("span", { staticClass: "en-text" }, [
                                  _vm._v("Remarks"),
                                ]),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    rules: _vm.workedInfo.HasWorkedInCompany
                                      ? "required"
                                      : null,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.workedInfo
                                                          .HasWorkedInCompanyDesc,
                                                      expression:
                                                        "workedInfo.HasWorkedInCompanyDesc",
                                                    },
                                                  ],
                                                  staticClass: "W-100",
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "50",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.workedInfo
                                                        .HasWorkedInCompanyDesc,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.workedInfo,
                                                        "HasWorkedInCompanyDesc",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveWorkedInfo)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }